import React from "react";

export function Logo({ size = 44, showText = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brenda-logo">
      <div
        className="relative flex items-center justify-center rounded-2xl overflow-hidden"
        style={{
          width: size,
          height: size,
          background: "linear-gradient(140deg, #D6A0A4 0%, #C58B90 45%, #E8CFD1 100%)",
          boxShadow: "0 6px 18px -6px rgba(197,139,144,0.6)",
        }}
      >
        <span
          className="absolute inset-[3px] rounded-[13px]"
          style={{ border: "1.5px solid rgba(217,179,130,0.85)" }}
        />
        <span
          className="font-serif leading-none relative"
          style={{ color: "#FCFBF9", fontSize: size * 0.5, fontWeight: 600 }}
        >
          B
        </span>
        <span className="absolute top-1 right-1.5 text-[7px]" style={{ color: "#F3D9A8" }}>
          ✦
        </span>
        <span className="absolute bottom-1.5 left-2 text-[5px]" style={{ color: "#F3D9A8" }}>
          ✦
        </span>
      </div>
      {showText && (
        <div className="leading-tight">
          <p className="font-serif text-xl tracking-tight" style={{ color: "#2C2A29" }}>
            Brenda Club
          </p>
        </div>
      )}
    </div>
  );
}
